var $ = require('jquery')

var min = 1

// Browser extensions (e.g. Proton Pass) inject elements with z-index up to 2147483647, the max browsers support.
// Stacking on top of them overflows: a window and its modal mask both clamp to the max and the mask wins by DOM order.
var FOREIGN_Z_INDEX_THRESHOLD = 2147483000

module.exports = function(els) {
    els = $(els || 'body > *')

    var zIndex
    if (els.length === 0) {
        zIndex = 1
    } else {
        var zIndexes = $.map(els, function(el) {
            var $el = $(el)
            if ($el.css('position') !== 'static' && $el.is(':visible') && !$el.is('iframe')) {
                var elZIndex = Number($el.css('z-index')) || 1
                return elZIndex < FOREIGN_Z_INDEX_THRESHOLD ? elZIndex : 1
            }
            return 1
        })

        zIndex = Math.max.apply(null, zIndexes)
    }

    return Math.max(zIndex, min)
}

module.exports.setMin = function(v) {
    min = v
}
